import { render, staticRenderFns } from "./ProductList4.vue?vue&type=template&id=a878fa2a&scoped=true&"
import script from "./ProductList4.vue?vue&type=script&lang=js&"
export * from "./ProductList4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a878fa2a",
  null
  
)

export default component.exports